import { Text } from '@elkaso-app/web-design';
import { Link } from 'react-router-dom';

export interface ITicketNumberCell {
  ticketId: string;
  ticketNo: string;
}

export const TicketNumberCell = ({ ticketId, ticketNo }: ITicketNumberCell) => {
  return (
    <Link to={`/app/ticket/details/${ticketId}`}>
      <Text color={'red.500'} fontWeight='500' _hover={{ color: 'red.500' }} _focus={{ color: 'red.500' }}>
        {ticketNo}
      </Text>
    </Link>
  );
};
